import makePhotoUrl from './makePhotoUrl';
import makePhotoSquare from './makePhotoSquare';
import { IMembers } from '../types/state.d';

type TMappedMembers = {
  id: string;
  picture?: string;
}[];
const mapMembers = (membersList: IMembers): TMappedMembers =>
  membersList.map(({ fundraisingPageGuid: id, profileImage: picture }) => ({
    id,
    picture: picture ? makePhotoUrl(makePhotoSquare(picture)) : undefined,
  }));

export default mapMembers;
